<div class="container-fluid" [ngClass]="alayticsService.currentTheme === 'material-dark' ? 'dark-theme' : ''">
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy' >"
    [showSpinner]="loading"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between pl-0">
      <div class="d-flex mt-3">
        <nb-icon
          icon="arrow-back"
          class="btn-back cursor-pointer mt-2 mr-2"
          (click)="router && router.url.includes('sign-up') ? router.navigateByUrl('/auth/login') : router.navigateByUrl('/manage-users')"
        >
        </nb-icon>
        <h5 class="quicksand-bold-label text-dark" *ngIf="router && !router.url.includes('sign-up')">
          <span *ngIf="!userToUpdate">Add</span>
          <span *ngIf="userToUpdate">Update</span> User
        </h5>
        <h5 class="quicksand-bold-label text-dark" *ngIf="router && router.url.includes('sign-up')">Sign Up</h5>
      </div>
    </div>
  </div>

  <div class="row user-info-content bg-white mt-2">
    <div class="col-md-3 user-profile-photo text-center" style="border-bottom: 1px solid #e2e2e2">
      <img
        [src]="currentProfile ? currentProfile?.image?.url : '/assets/images/no-profile-image.png'"
        alt="no-profile-image"
        class="user-profile"
      />

      <br />
      <label class="quicksand-normal-label mt-3 upload-picture-label"
        >Click here to
        <span
          class="upload cursor-pointer"
          (click)="fileInput.click(); alayticsService.trackEvent('Upload Photo', 'Add user signup')"
          >Upload Photo</span
        ></label
      >

      <br />
      <button
        nbButton
        color="warn"
        class="{{ !userToUpdate?.isDisable ? ' delete' : 'enable' }} delete-lesson-plan m-2 w-100 quicksand-bold-label text-capitalize text-white"
        (click)="openConfirmationDialog()"
        style="height: 42px; border: none"
        *ngIf="userToUpdate"
      >
        <span *ngIf="!userToUpdate?.isDisable">Disable</span>
        <span *ngIf="userToUpdate?.isDisable">Enable</span>
      </button>
      <button
        style="height: 42px; border: none"
        class="cursor-pointer quicksand-bold-label add-user mt-3"
        *ngIf="userToUpdate && storageService.checkUserRole(addUserForm.value.role, 'teacher')"
        (click)="openManageClassroomsModal()"
      >
        Manage Classrooms
      </button>

      <label
        class="quicksand-normal-label mt-2"
        style="font-size: 12.5px; text-align: left; margin: 0 24%"
        *ngIf="userToUpdate && storageService.checkUserRole(addUserForm.value.role, 'teacher')"
      >
        View this teacher's classrooms to assign or revoke permissions to a substitute teacher
      </label>
    </div>

    <div class="col-md-9" style="border-bottom: 1px solid #e2e2e2">
      <form [formGroup]="addUserForm">
        <ng-select
          #select
          [items]="cities"
          [searchable]="false"
          [(ngModel)]="selectedCity"
          bindLabel="name"
          bindValue="name"
          [searchFn]="testSearch"
          (search)="onSearch()"
        >
          <ng-template ng-header-tmp>
            <div class="form-group has-feedback">
              <input
                style="width: 100%; line-height: 24px"
                type="text"
                class="form-control"
                id="inputValidation"
                placeholder="Search"
                (input)="select.filter($event.target.value)"
              />
              <span class="form-control-feedback"
                ><svg focusable="false">
                  <use xmlns="http://www.w3.org/2000/svg" attr.xlink:href="styleguide.svg#{{ id }}"></use>
                </svg>
              </span>
            </div>
          </ng-template>
        </ng-select>
        <div class="row p-0">
          <div class="col-md-6">
            <div class="form-group" *ngIf="router && !router.url.includes('sign-up')">
              <label class="label form-control-label quicksand-normal-label"
                >Select School <span class="required-field">*</span></label
              >

              <mat-select
                placeholder="Select User School"
                formControlName="school"
                [disabled]="userToUpdate"
                (selectionChange)="addSchoolCode($event.value)"
                class="select-bar w-100"
                (openedChange)="onDropdownOpen()"
              >
                <!-- Search School -->

                <input
                  #schoolSearchInput
                  nbInput
                  placeholder="Search School..."
                  formControlName="schoolSearch"
                  (keydown)="$event.stopPropagation()"
                  class="school-search-bar quicksand-normal-label"
                  (click)="$event.stopPropagation()"
                />

                <mat-option
                  *ngFor="let school of filteredSchools"
                  [value]="school.id"
                  class="quicksand-normal-label signup-activity-options"
                >
                  {{ school.name }}
                </mat-option>
              </mat-select>

              <label
                class="quicksand-bold-label error-label"
                *ngIf="addUserForm.controls.school.invalid && (addUserForm.controls.school.dirty || addUserForm.controls.school.touched)"
                >Select School</label
              >
            </div>

            <div class="form-group" *ngIf="router && router.url.includes('sign-up')">
              <label class="label form-control-label quicksand-normal-label"
                >School Code <span class="required-field">*</span></label
              >
              <input
                type="text"
                class="nb-input"
                nbInput
                fullWidth
                formControlName="schoolCode"
                placeholder="Enter School Code"
                (keyup)="getSchoolByCode($event)"
                ngxTrimWhitespaces
              />
              <label
                class="quicksand-bold-label error-label"
                *ngIf="addUserForm.controls.schoolCode.invalid && (addUserForm.controls.schoolCode.dirty || addUserForm.controls.schoolCode.touched)"
                >Enter School Code</label
              >

              <label class="error-label quicksand-bold-label" *ngIf="!isShool && addUserForm.value.schoolCode"
                >No School Found For Current Code</label
              >
            </div>
          </div>

          <div class="col-md-6" *ngIf="router && router.url.includes('sign-up') && isShool">
            <div class="form-group">
              <label class="label form-control-label quicksand-normal-label">Selected School</label>
              <nb-select
                placeholder="Select User School"
                class="select-bar w-100"
                [disabled]="true"
                formControlName="school"
              >
                <nb-option class="quicksand-normal-label" *ngFor="let school of schools" [value]="school.id">
                  {{ school.name }}</nb-option
                >
              </nb-select>
              <label
                class="quicksand-bold-label error-label"
                *ngIf="addUserForm.controls.school.invalid && (addUserForm.controls.school.dirty || addUserForm.controls.school.touched)"
                >Select School</label
              >
            </div>
          </div>

          <div class="col-md-6" *ngIf="!router.url.includes('sign-up')">
            <div class="form-group">
              <label class="label form-control-label quicksand-normal-label"
                >Select Role <span class="required-field">*</span></label
              >
              <nb-select
                placeholder="Select User Role"
                class="select-bar w-100"
                (selectedChange)="getUserRole($event)"
                formControlName="role"
                [disabled]="userToUpdate"
              >
                <nb-option class="quicksand-normal-label" *ngFor="let role of roles" [value]="role.id">
                  {{ role.name }}</nb-option
                >
              </nb-select>
              <label
                class="quicksand-bold-label error-label"
                *ngIf="addUserForm.controls.role.invalid && (addUserForm.controls.role.dirty || addUserForm.controls.role.touched)"
                >Select Role</label
              >
            </div>
          </div>

          <div class="col-md-6" *ngIf="router.url.includes('sign-up')">
            <div class="form-group">
              <label class="label form-control-label quicksand-normal-label"
                >Email <span class="required-field">*</span></label
              >
              <input
                type="email"
                class="nb-input"
                nbInput
                fullWidth
                formControlName="email"
                placeholder="Enter Email"
              />
              <label
                class="quicksand-bold-label error-label"
                *ngIf="addUserForm.controls.email.invalid && (addUserForm.controls.email.dirty || addUserForm.controls.email.touched)"
                >Enter Valid Email</label
              >

              <button
                nbButton
                *ngIf="router.url.includes('sign-up') && !isValidUser"
                class="float-right mt-2 quicksand-bold-label validate-user-btn text-capitalize text-white"
                [disabled]="!isShool || !addUserForm.value.email"
                (click)="addUser(true)"
              >
                Validate User
              </button>
            </div>
          </div>

          <ng-container *ngIf="isValidUser">
            <div class="col-md-6">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label"
                  >First Name <span class="required-field">*</span></label
                >
                <input
                  type="text"
                  class="nb-input text-capitalize"
                  nbInput
                  fullWidth
                  formControlName="firstName"
                  placeholder="Enter First Name"
                  maxlength="25"
                />
                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="addUserForm.controls.firstName.invalid && (addUserForm.controls.firstName.dirty || addUserForm.controls.firstName.touched)"
                  >Enter Valid First Name</label
                >
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label"
                  >Last Name <span class="required-field">*</span></label
                >
                <input
                  type="text"
                  class="nb-input text-capitalize"
                  nbInput
                  fullWidth
                  formControlName="lastName"
                  placeholder="Enter Last Name"
                  maxlength="25"
                />
                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="addUserForm.controls.lastName.invalid && (addUserForm.controls.lastName.dirty || addUserForm.controls.lastName.touched)"
                  >Enter Valid Last Name</label
                >
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label"
                  >School-Issued ID <span class="required-field">*</span></label
                >
                <input
                  type="text"
                  class="nb-input"
                  nbInput
                  fullWidth
                  formControlName="id_code"
                  placeholder="Enter Your Unique Id Code"
                  maxlength="12"
                />
                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="addUserForm.controls.id_code.invalid && (addUserForm.controls.id_code.dirty || addUserForm.controls.id_code.touched)"
                  >Enter Your Valid School-Issued ID upto 12 Digit</label
                >
              </div>
            </div>

            <div class="col-md-6" *ngIf="storageService.checkUserRole(addUserForm.value.role, 'student')">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label"
                  >Select Grade <span class="required-field">*</span></label
                >
                <nb-select placeholder="Select Student Grade" class="select-bar w-100" formControlName="grade">
                  <nb-option class="quicksand-normal-label" *ngFor="let grade of grades" [value]="grade.id">
                    {{ grade.grade }}</nb-option
                  >
                </nb-select>
                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="addUserForm.controls.grade.invalid && (addUserForm.controls.grade.dirty || addUserForm.controls.grade.touched)"
                  >Select Grade</label
                >
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label">Date Of Birth</label>
                <br />
                <div class="d-flex">
                  <input
                    matInput
                    [matDatepicker]="Birthdate"
                    class="w-100 cursor-pointer input-field mat-input-datepicker"
                    placeholder="Select Birth Date"
                    formControlName="dob"
                    [max]="maxDateBirthdate"
                    [readonly]="true"
                  />
                  <mat-datepicker-toggle class="mat-picker-toggle" matSuffix [for]="Birthdate"></mat-datepicker-toggle>
                  <mat-datepicker #Birthdate></mat-datepicker>
                </div>
              </div>
            </div>

            <div class="col-md-6" *ngIf="!router.url.includes('sign-up')">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label"
                  >Email <span class="required-field">*</span>
                  <span style="font-size: 12px" class="quicksand-normal-label ml-1"
                    >(Please add email carefully, we are sending email to the user for password change)</span
                  ></label
                >
                <input
                  type="email"
                  class="nb-input"
                  nbInput
                  fullWidth
                  formControlName="email"
                  placeholder="Enter Email"
                  maxlength="50"
                  [readonly]="userToUpdate"
                />
                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="addUserForm.controls.email.invalid && (addUserForm.controls.email.dirty || addUserForm.controls.email.touched)"
                  >Enter Valid Email</label
                >
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label">Phone Number</label>
                <input
                  type="text"
                  class="nb-input"
                  nbInput
                  fullWidth
                  formControlName="contact"
                  placeholder="Enter Phone Number"
                  mask="(000) 000-0000"
                />
                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="addUserForm.controls.contact.invalid && (addUserForm.controls.contact.dirty || addUserForm.controls.contact.touched)"
                  >Enter Valid Phone Number</label
                >
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label">Home Address</label>
                <input
                  type="text"
                  class="nb-input"
                  nbInput
                  fullWidth
                  formControlName="address"
                  placeholder="Enter Address"
                  maxlength="100"
                />
              </div>
            </div>

            <div class="col-md-6" *ngIf="storageService.checkUserRole(addUserForm?.value?.role, 'student')">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label">Parent Email Address</label>
                <input
                  type="text"
                  class="nb-input"
                  nbInput
                  fullWidth
                  formControlName="parentEmail"
                  placeholder="Enter Parent Email Address"
                />

                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="addUserForm.controls.parentEmail.invalid && (addUserForm.controls.parentEmail.dirty || addUserForm.controls.parentEmail.touched)"
                  >Enter Valid Email Address</label
                >
              </div>
            </div>

            <div class="col-md-6" *ngIf="!userToUpdate">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label"
                  >Password <span class="required-field">*</span></label
                >
                <input
                  [type]="isShowPassword ? 'text' : 'password'"
                  class="nb-input"
                  nbInput
                  fullWidth
                  formControlName="password"
                  placeholder="Password"
                  autocomplete="new-password"
                />

                <span class="p-viewer cursor-pointer" (click)="isShowPassword = !isShowPassword">
                  <nb-icon icon="eye-off-outline" *ngIf="!isShowPassword"></nb-icon>
                  <nb-icon icon="eye-outline" *ngIf="isShowPassword"></nb-icon>
                </span>
                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="addUserForm.controls.password.invalid && (addUserForm.controls.password.dirty || addUserForm.controls.password.touched)"
                  >Enter Valid Password with a minimum 8 characters and atleast 1 Number</label
                >
              </div>
            </div>

            <div class="col-md-6" *ngIf="!userToUpdate">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label"
                  >Confirm Password <span class="required-field">*</span></label
                >
                <input
                  [type]="isShowConfirmPassword ? 'text' : 'password'"
                  class="nb-input"
                  nbInput
                  fullWidth
                  formControlName="confirmPassword"
                  placeholder="Confirm Password"
                  minlength="8"
                />
                <span class="p-viewer cursor-pointer" (click)="isShowConfirmPassword = !isShowConfirmPassword">
                  <nb-icon icon="eye-off-outline" *ngIf="!isShowConfirmPassword"></nb-icon>
                  <nb-icon icon="eye-outline" *ngIf="isShowConfirmPassword"></nb-icon>
                </span>

                <label
                  class="error-label quicksand-bold-label"
                  *ngIf="addUserForm.value.password && addUserForm.value.confirmPassword && addUserForm.value.password !== addUserForm.value.confirmPassword"
                  >The password does not match</label
                >

                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="
                    (!addUserForm.value.password || !addUserForm.value.confirmPassword) &&
                    addUserForm.controls.confirmPassword.invalid &&
                    (addUserForm.controls.confirmPassword.dirty || addUserForm.controls.confirmPassword.touched)
                  "
                  >Enter Valid Password with a minimum 8 characters and atleast 1 Number</label
                >
              </div>
            </div>
            <div class="col-md-6" *ngIf="addUserForm?.value?.role === 20">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label">Student Code</label>
                <div formArrayName="students">
                  <div *ngFor="let student of studentsDetails.controls; let i = index">
                    <div formGroupName="{{ i }}" class="d-flex">
                      <div class="input-field w-100 d-flex input-field-code pt-2">
                        <input
                          type="text"
                          nbInput
                          fullWidth
                          placeholder="Enter Student Unique Code "
                          formControlName="userCode"
                          [readOnly]="validatedStudentCodes.includes(studentsDetails?.controls[i]?.value?.userCode)"
                          class="{{ validatedStudentCodes.includes(studentsDetails?.controls[i]?.value?.userCode) ? 'validated-student' : '' }}"
                          maxlength="12"
                          (keyup)="utilService.validateSchoolByCode($event, studentsDetails.controls[i].get('userCode'))"
                        />

                        <input
                          type="text"
                          nbInput
                          fullWidth
                          placeholder="Student Name"
                          class="ml-2 {{
                            validateStudents?.length > 0 && validateStudents[i]?.profileData?.studentCode === studentsDetails?.controls[i]?.value?.userCode
                              ? 'validated-student'
                              : ''
                          }}"
                          readonly
                          *ngIf="
                            validateStudents?.length > 0 && validateStudents[i]?.profileData?.studentCode === studentsDetails?.controls[i]?.value?.userCode
                          "
                          value="{{ validateStudents[i]?.firstName + ' ' + validateStudents[i]?.lastName }}"
                        />

                        <nb-icon
                          class="button-inside-input cursor-pointer"
                          nbButtonIcon
                          icon="close-outline"
                          (click)="removeUser(i)"
                        ></nb-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                nbButton
                class="text-capitalize quicksand-bold-label btn-validate"
                (click)="addStudentCode()"
                [disabled]="!isStudentValidated"
              >
                Add Student
              </button>
              <button
                nbButton
                class="text-capitalize quicksand-bold-label btn-validate ml-2"
                (click)="validateStudent()"
                [disabled]="isStudentValidated"
              >
                Validate Student
              </button>
              <!-- <label
               
                class="quicksand-bold-label error-label"
                *ngIf="
                  registrationForm.controls.student.invalid &&
                  (registrationForm.controls.student.dirty ||
                    registrationForm.controls.student.touched)
                "
                >Please Enter Valid Student Code</label
              > -->
            </div>

            <div class="col-md-6" *ngIf="userToUpdate">
              <button
                nbButton
                *ngIf="storageService.checkUserRole(addUserForm.value.role, 'student') && addUserForm.value.studentCode === ''"
                class="add-user text-capitalize quicksand-bold-label w-auto"
                (click)="getStudentCode(true)"
              >
                Generate ID
              </button>
              <div class="form-group" *ngIf="addUserForm.value.studentCode !== ''">
                <label class="label form-control-label quicksand-normal-label">Student Code</label>
                <input
                  type="text"
                  class="nb-input"
                  nbInput
                  fullWidth
                  formControlName="studentCode"
                  placeholder="Student Code"
                  readonly
                />
              </div>
            </div>
            <ng-container
              *ngIf="addUserForm.value.role && storageService.checkUserRole(addUserForm.value.role, 'admin') && router.url.includes('manage-users')"
            >
              <div class="col-md-6">
                <div class="form-group">
                  <label class="label form-control-label quicksand-normal-label">Teacher View Access </label>
                  <br />
                  <span class="description quicksand-bold-label"
                    >(This will allow the user to view and track Teacher's Classrooms)</span
                  >
                  <nb-radio-group
                    name="teacher-view-access-radio-group"
                    formControlName="teacherViewAccess"
                    class="d-flex bell-schedule-radio"
                  >
                    <nb-radio value="true"> Yes </nb-radio>
                    <nb-radio value="false"> No </nb-radio>
                  </nb-radio-group>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="label form-control-label quicksand-normal-label">User Management Privileges </label>
                  <br />
                  <span class="description quicksand-bold-label"
                    >(This will allow the user to create new users and delete existing users)</span
                  >
                  <nb-radio-group
                    name="user-management-privileges-radio-group"
                    formControlName="userManangementPrivileges"
                    class="d-flex bell-schedule-radio"
                  >
                    <nb-radio value="true"> Yes </nb-radio>
                    <nb-radio value="false"> No </nb-radio>
                  </nb-radio-group>
                </div>
              </div>

              <div class="col-md-6" *ngIf="user?.user?.role_id === 19">
                <div class="form-group">
                  <label class="label form-control-label quicksand-normal-label"
                    >View Multiple Schools Privileges
                  </label>
                  <br />
                  <span class="description quicksand-bold-label"
                    >(This will allow the user to view other school dashboard and existing users)</span
                  >
                  <nb-radio-group
                    name="multiple-schools-management-privileges-radio-group"
                    formControlName="multipleSchoolPrivilages"
                    class="d-flex bell-schedule-radio"
                  >
                    <nb-radio value="true"> Yes </nb-radio>
                    <nb-radio value="false"> No </nb-radio>
                  </nb-radio-group>
                </div>
              </div>

              <div
                class="col-md-6"
                *ngIf="
                  (user?.user?.role_id === 19 || user?.user?.profileData?.isViewMultipleSchools === true) &&
                  addUserForm?.value?.multipleSchoolPrivilages === 'true'
                "
              >
                <div class="form-group">
                  <label class="label form-control-label quicksand-normal-label"
                    >Select Multiple Schools Privileges
                  </label>
                  <br />
                  <span class="description quicksand-bold-label"
                    >(User can see selected school Privileges and the dashboard)</span
                  >
                  <br />

                  <nb-select
                    multiple
                    placeholder="Select Schools"
                    class="w-100 mt-2 select-bar"
                    formControlName="selectedSchools"
                  >
                    <nb-option
                      class="quicksand-normal-label"
                      *ngFor="let school of currentSchools"
                      [value]="school?.id"
                      >{{ school?.name }}</nb-option
                    >
                  </nb-select>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </form>
    </div>

    <form
      [formGroup]="addUserForm"
      class="row"
      *ngIf="addUserForm.value.role && storageService.checkUserRole(addUserForm.value.role, 'teacher') && !router.url.includes('sign-up')"
      style="padding: 0 15px"
    >
      <div class="col-md-3" style="border-bottom: 1px solid #e2e2e2">
        <div
          class=""
          *ngIf="addUserForm.value.role && storageService.checkUserRole(addUserForm.value.role, 'teacher') && !router.url.includes('sign-up')"
        >
          <h6 class="quicksand-bold-label pl-3 pt-3">Academic Information</h6>
        </div>
      </div>
      <div class="col-md-9" style="border-bottom: 1px solid #e2e2e2">
        <div
          class="pl-3 pr-3 mt-2"
          *ngIf="addUserForm.value.role && storageService.checkUserRole(addUserForm.value.role, 'teacher') && !router.url.includes('sign-up')"
        >
          <div class="row pt-2">
            <div class="col-md-12">
              <div class="col-md-3"></div>
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label"
                  >Date of Criminal Background Clearance</label
                >
                <br />
                <div class="d-flex">
                  <input
                    matInput
                    [matDatepicker]="dateOfCriminalBackground"
                    class="nb-input w-100 cursor-pointer input-field mat-input-datepicker"
                    placeholder="Select Criminal Background Clearance"
                    formControlName="dateOfCriminalBackground"
                    [max]="minDate"
                    [min]="addUserForm.value.dob"
                    [readonly]="true"
                    (dateChange)="onCriminalBackgroundDateChange($event)"
                  />
                  <mat-datepicker-toggle
                    class="mat-picker-toggle"
                    matSuffix
                    [for]="dateOfCriminalBackground"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #dateOfCriminalBackground></mat-datepicker>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label">Date of Hire</label>
                <br />
                <div class="d-flex">
                  <input
                    matInput
                    [matDatepicker]="dateOfHire"
                    class="input-field w-100 mat-input-datepicker cursor-pointer"
                    placeholder="Select Date of Hire"
                    formControlName="dateOfHire"
                    [min]="minDateOfHire"
                    [readonly]="true"
                  />
                  <mat-datepicker-toggle class="mat-picker-toggle" matSuffix [for]="dateOfHire"></mat-datepicker-toggle>
                  <mat-datepicker #dateOfHire [disabled]="!addUserForm.value.dateOfCriminalBackground"></mat-datepicker>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label">TB Clearance Date</label>
                <br />
                <div class="d-flex">
                  <input
                    matInput
                    [matDatepicker]="tbClearanceDate"
                    class="input-field w-100 mat-input-datepicker cursor-pointer"
                    placeholder="Select TB Clearance Date"
                    formControlName="tbClearanceDate"
                    [min]="addUserForm.value.dob"
                    [max]="minDate"
                    [readonly]="true"
                    (dateChange)="onTBClearanceDateChange($event)"
                  />
                  <mat-datepicker-toggle
                    class="mat-picker-toggle"
                    matSuffix
                    [for]="tbClearanceDate"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #tbClearanceDate></mat-datepicker>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label">TB Expiration Date</label>
                <br />
                <div class="d-flex">
                  <input
                    matInput
                    [matDatepicker]="tbExpirationDate"
                    class="input-field w-100 mat-input-datepicker cursor-pointer"
                    placeholder="Select TB Expiration Date"
                    formControlName="tbExpirationDate"
                    [min]="maxDateTbExpiration"
                  />
                  <mat-datepicker-toggle
                    class="mat-picker-toggle"
                    matSuffix
                    [for]="tbExpirationDate"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #tbExpirationDate [disabled]="!addUserForm.value.tbClearanceDate"></mat-datepicker>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label">Credential Document Number</label>
                <br />

                <input
                  nbInput
                  class="nb-input w-100 cursor-pointer"
                  placeholder="Add Credential Document Number"
                  formControlName="credentialDocumentNumber"
                  maxlength="13"
                />
              </div>
            </div>

            <!-- <div class="col-md-6">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label"
                  >Credential Type and Employment Restriction</label
                >
                <br />

                <input
                  nbInput
                  class="nb-input w-100 cursor-pointer"
                  placeholder="Add Credential Type Employment Restriction"
                  formControlName="credentialTypeEmployment"
                  maxlength="50"
                />
              </div>
            </div> -->
            <!-- 
            <div class="col-md-6">
              <div class="form-group">
                <label class="label form-control-label quicksand-normal-label"
                  >Credential Expiration Date</label
                >
                <br />
                <div class="d-flex">
                  <input
                    matInput
                    [matDatepicker]="credentialExpirationDate"
                    class="input-field w-100 mat-input-datepicker cursor-pointer"
                    placeholder="Select Credentical Expiration Date"
                    formControlName="credentialExpirationDate"
                    [readonly]="true"
                  />
                  <mat-datepicker-toggle
                    class="mat-picker-toggle"
                    matSuffix
                    [for]="credentialExpirationDate"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #credentialExpirationDate></mat-datepicker>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </form>

    <div style="width: 100%">
      <div class="col-md-12 d-flex add-user-content pb-3">
        <button
          nbButton
          class="add-user text-capitalize quicksand-bold-label mt-3"
          (click)="addUser()"
          [title]="
            addUserForm.invalid || addUserForm.value.password !== addUserForm.value.confirmPassword
              ? 'Please fill all the required fields with * and with matching passwords'
              : 'Save'
          "
        >
          <span *ngIf="!router.url.includes('sign-up')"
            ><span *ngIf="!userToUpdate">Add</span> <span *ngIf="userToUpdate">Update</span> User</span
          >
          <span *ngIf="router.url.includes('sign-up')">Sign Up</span>
        </button>
        <button
          nbButton
          class="bg-white text-capitalize quicksand-bold-label cancel ml-2 mt-3"
          (click)="
            addUserForm.reset();
            router && router.url.includes('sign-up') ? router.navigateByUrl('/auth/login') : router.navigateByUrl('/manage-users');
            alayticsService.trackEvent('Add User Modal', 'Add User Signup')
          "
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>

<div class="text-center" [ngClass]="alayticsService.currentTheme">
  <span class="file-upload-input">
    <input
      type="file"
      name="file"
      #fileInput
      accept="image/*,.pptx,.pdf,.ppt"
      (change)="onFileChange($event)"
      class="inputfile"
    />
  </span>
</div>

<!-- transfer classroom modal -->
<ng-template #myModal let-modal>
  <div
    class="add-classroom-modal manage-classroom"
    [ngClass]="alayticsService.currentTheme === 'material-dark' ? 'dark-theme' : ''"
  >
    <div class="modal-header d-flex justify-content-between align-items-center w-100">
      <div class="d-flex align-items-center">
        <span class="icon-add-classroom">
          <nb-icon icon="plus-outline"></nb-icon>
        </span>
        <h6 class="add-clasroom-text quicksand-bold-label m-0">Manage Teacher Classrooms</h6>
      </div>
      <span
        class="icon-close-classroom-modal d-block cursor-pointer"
        (click)="modalService.dismissAll(modalRef)"
        style="padding: 8px"
      >
        <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
      </span>
    </div>

    <div class="modal-body">
      <nb-card
        class="assigned-classroom-card {{
          userClassrooms?.assigned_classrooms.length === 0
            ? 'small-card-height'
            : userClassrooms?.assigned_classrooms.length === 2
            ? 'medium-card-height'
            : userClassrooms?.assigned_classrooms.length > 3
            ? 'large-card-height'
            : 'general-card-height'
        }} shadow-none"
      >
        <nb-card-header style="background-color: #efefef">
          <h6 class="quicksand-bold-label">Assigned Classrooms</h6>
        </nb-card-header>
        <nb-card-body class="add-background">
          <div class="row mt-2" *ngFor="let classroom of userClassrooms?.assigned_classrooms">
            <div class="col-md-3">
              <label class="quicksand-bold-label">{{ classroom?.name }}</label>
            </div>
            <div class="col-md-2">
              <div class="classroom-code quicksand-bold-label text-center">
                {{ classroom?.code }}
              </div>
            </div>
            <div class="col-md-4">
              <mat-select
                class="selected-pacing-plans quicksand-bold-label"
                placeholder="Assigned Teachers..."
                [value]="classroom?.new_user_ids[0]"
              >
                <mat-option
                  *ngFor="let user of classroom?.new_user_ids"
                  [value]="user"
                  class="quicksand-bold-label select-range"
                  >{{ user?.firstName | titlecase }} {{ user?.lastName | titlecase }}</mat-option
                >
              </mat-select>
            </div>
            <div class="col-md-3">
              <button
                nbButton
                class="quicksand-bold-label text-white text-capitalize btn-revoke"
                (click)="revokeClassroom(classroom)"
              >
                Revoke
              </button>
            </div>
          </div>
          <label class="quicksand-bold-label" *ngIf="userClassrooms?.assigned_classrooms.length === 0">
            No assigned classrooms found!
          </label>
        </nb-card-body>
      </nb-card>

      <hr />

      <h6 class="quicksand-bold-label">Classrooms to assign</h6>

      <form [formGroup]="assignClassroomsForm">
        <div class="form-group">
          <label class="form-control-label quicksand-bold-label"
            >Select Classrooms <span class="required-field">*</span></label
          >
          <br />

          <mat-select
            multiple
            class="selected-pacing-plans"
            placeholder="Select Classrooms..."
            #sl
            formControlName="classrooms"
          >
            <mat-option
              *ngFor="let classroom of userClassrooms?.non_assigned_classrooms"
              [value]="classroom"
              class="quicksand-bold-label select-range"
              >{{ classroom?.name }} | {{ classroom?.code }}</mat-option
            >

            <button
              (click)="sl.close()"
              mat-raised-button
              class="float-right m-1 apply-button text-capitalize text-white quicksand-bold-label"
            >
              Ok
            </button>
          </mat-select>
        </div>

        <div class="form-group">
          <label class="form-control-label quicksand-bold-label"
            >Select Teacher <span class="required-field">*</span></label
          >
          <br />

          <mat-select
            multiple
            class="selected-pacing-plans"
            placeholder="Select Teacher..."
            #ml
            formControlName="users"
          >
            <mat-option
              *ngFor="let teacher of userClassrooms?.teachers"
              [value]="teacher.id"
              class="quicksand-bold-label select-range"
              >{{ teacher?.firstName }} {{ teacher?.lastName }}</mat-option
            >

            <button
              (click)="ml.close()"
              mat-raised-button
              class="float-right m-1 apply-button text-capitalize text-white quicksand-bold-label"
            >
              Ok
            </button>
          </mat-select>
        </div>

        <div class="form-group text-right">
          <button
            nbButton
            class="cancel quicksand-bold-label text-capitalize"
            (click)="modalService.dismissAll(modalRef); assignClassroomsForm.reset()"
          >
            Cancel
          </button>
          <button
            nbButton
            class="save quicksand-bold-label text-capitalize btn-validate ml-2"
            style="width: 20%"
            (click)="updateClassrooms()"
          >
            Save
          </button>
        </div>
      </form>

      <label class="quicksand-bold-label" *ngIf="userClassrooms?.non_assigned_classrooms.length === 0">
        No classrooms found!
      </label>
    </div>
    <div class="modal-footer d-flex justify-content-end"></div>
  </div>
</ng-template>

<!-- <ng-template #dialogArchive>
  <div class="text-center">
    <img
      src="/assets/icons/featured icon.svg"
      alt="delete-icon"
      loading="lazy"
    />
    <br />

    <label class="label-delete-lesson-plan mt-2 quicksand-bold-label">
      <span *ngIf="!userToUpdate.isDisable">Disable User</span>
      <span *ngIf="userToUpdate.isDisable">Enable user</span>
    </label>
    <br />
    <label class="delete-lesson-plan-confirmation quicksand-bold-label"
      >Are you sure want to
      <span *ngIf="!userToUpdate.isDisable">Disable</span>
      <span *ngIf="userToUpdate.isDisable">Enable</span> this user?</label
    >
    <br />
    <span class="quicksand-bold-label" *ngIf="!userToUpdate.isDisable">
      Disabling the User makes them inactive throughout portal, you can manage
      them in the inactive users side menu!
    </span>

    <span class="quicksand-bold-label" *ngIf="userToUpdate.isDisable">
      Enabling the User makes them active throughout portal, they can able to
      login through the portal again!
    </span>
  </div>
  <br />

  <div class="d-flex">
    <button
      nbButton
      class="bg-white bg-white-color m-2 w-100 quicksand-bold-label text-capitalize"
      (click)="matDialog.closeAll()"
    >
      Cancel
    </button>
    <button
      nbButton
      color="warn"
      class="{{
        !userToUpdate.isDisable ? ' delete' : 'enable'
      }} m-2 w-100 quicksand-bold-label text-capitalize text-white"
      (click)="disableUser(user)"
    >
      <span *ngIf="!userToUpdate.isDisable">Disable</span>
      <span *ngIf="userToUpdate.isDisable">Enable</span>
    </button>
  </div>
</ng-template> -->
